import { Typography } from "@sgi/gravity";
import { Flex } from "@chakra-ui/react";

interface TitleProps {
  text: string;
}

export default function Title(props: TitleProps) {
  return (
    <Flex style={{ paddingTop: "154px" }} data-testid="title-test">
      <Typography variant="h2">
        {props.text}
      </Typography>
    </Flex>
  );
}
